import { useMutation, useQueryClient } from "react-query"
import { useReloadBackordersCounts } from "../showBackordersCount"
import { deleteBackorder } from "./deleteBackorder"
import { CIS_BACKORDERS_KEY, ShowBackordersResponse } from "../showBackorders"

export function useDeleteBackorder() {
    const queryClient = useQueryClient()
    const { resetBackorderCounts } = useReloadBackordersCounts()
    const mutation = useMutation(deleteBackorder, {
        onSuccess: (_, request) => {
            queryClient.setQueriesData<{ pages: ShowBackordersResponse[] | undefined }>(CIS_BACKORDERS_KEY, (prev) => {
                resetBackorderCounts()
                return {
                    ...prev,
                    pages: prev?.pages?.map((page) => ({
                        ...page,
                        backorders: page.backorders.filter((b) => b !== request.backorder),
                    })),
                }
            })
        },
    })

    return { deleteBackorder: mutation.mutateAsync, isDeleting: mutation.isLoading }
}
